export default "__VITE_ASSET__C5HtqkcR__"